module.exports = __webpack_public_path__ + "img/keurkamer.e342c71b.png";